import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [showIndicator, setShowIndicator] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setShowIndicator(scrollY < 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToNextSection = () => {
    const nextSection = document.getElementById('portfolio');
    if (nextSection) {
      const headerHeight = 70;
      const targetPosition = nextSection.offsetTop - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero" id="inicio">
      <div className="hero-video">
        <video
          src="/Site.mp4"
          autoPlay
          muted
          loop
          playsInline
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        ></video>
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="300">
          Realizando sonhos através de experiências únicas
        </p>
        <div 
          className={`scroll-indicator ${showIndicator ? '' : 'hidden'}`}
          data-aos="fade-up" 
          data-aos-delay="800"
        >
          <span>Descubra mais</span>
          <i 
            className="fas fa-chevron-down scroll-arrow" 
            onClick={scrollToNextSection}
            style={{ cursor: 'pointer' }}
          ></i>
        </div>
      </div>
    </section>
  );
};

export default Hero;